function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 14.7506H11.0079M11.0004 7.25024V11.9379M20.3758 11.0004C20.3758 5.82237 16.1784 1.625 11.0004 1.625C5.82237 1.625 1.625 5.82237 1.625 11.0004C1.625 16.1784 5.82237 20.3758 11.0004 20.3758C16.1784 20.3758 20.3758 16.1784 20.3758 11.0004Z",
    stroke: "#E5A503",
    style: {
      stroke: "#E5A503",
      stroke: "color(display-p3 0.8980 0.6471 0.0118)",
      strokeOpacity: 1
    },
    strokeWidth: 1.75789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoy);
export default __webpack_public_path__ + "static/media/infoy.e65190ce17f61623101c2ab6a07f9d06.svg";
export { ForwardRef as ReactComponent };